import type { SUMMARY_ROUTE } from 'cpool-constants';

import type { LeadListFilter } from '../schemas/route.schema';
import type { QueryPositionValue } from '~/store/queryPositionStore';
import { LoanRequestResolver_GetSummary } from 'cpool-tables/backend-resolvers';

type BuildLoanRequestGetSummarySearchParamsArgs = {
    filter: Pick<
        LeadListFilter,
        | 'adviser'
        | 'bank'
        | 'bucket'
        | 'page'
        | 'pageSize'
        | 'partnerLevel'
        | 'resubmission'
        | 'status'
        | 'subStatus'
        | 'tag'
    >;
    position?: QueryPositionValue;
    route: SUMMARY_ROUTE;
    permissionsActionFilter?: Parameters<LoanRequestResolver_GetSummary>[1]['permissionsActionFilter'];
};

/** Single source of truth for loan-request getSummary query params (React Query key + API). */
export const buildLoanRequestGetSummarySearchParams = ({
    filter,
    position,
    route,
    permissionsActionFilter,
}: BuildLoanRequestGetSummarySearchParamsArgs) => {
    const { adviser, bank, bucket, page, pageSize, partnerLevel, resubmission, status, subStatus, tag } = filter;
    return {
        filters: {
            adviser,
            bank,
            bucket,
            partnerLevel,
            resubmission,
            subStatus,
            tag,
        },
        limit: pageSize,
        offset: pageSize * (page - 1),
        position,
        route,
        status,
        permissionsActionFilter,
    };
};
